import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";
import { getSourceReport, exportReportCsv } from "../../api/clientAnalyticsApi";
import ClientAnalyticsDateRange from "../../components/clientPortal/ClientAnalyticsDateRange";
import ClientSimpleBarChart from "../../components/clientPortal/ClientSimpleBarChart";
import { ClientPortalError, ClientPortalLoading } from "../../components/clientPortal/ClientPortalStates";
import { buildAnalyticsQuery, formatPercent } from "../../utils/clientAnalyticsQuery";

const ClientSourceReportPage = () => {
  const { clientViewId } = useParams();
  const [preset, setPreset] = useState("30d");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const paths = useClientPortalPaths();

  useEffect(() => {
    setLoading(true);
    getSourceReport(clientViewId, buildAnalyticsQuery({ preset, dateFrom, dateTo }))
      .then((body) => setRows(body.sources || []))
      .catch((e) => setErrorMessage(e.message || "Unable to load report."))
      .finally(() => setLoading(false));
  }, [clientViewId, preset, dateFrom, dateTo]);

  const chartData = rows.map((r) => ({ label: r.sourceName, value: r.opportunityCount }));

  return (
    <>
      <section className="panel-card">
        <p className="eyebrow">
          <Link to={paths.viewSection(clientViewId, "reports")}>Reports</Link> / Sources
        </p>
        <div className="client-portal-section-header">
          <h2>Source Attribution Report</h2>
          <button
            type="button"
            className="midpoint-share-button secondary"
            onClick={() =>
              exportReportCsv(clientViewId, {
                ...buildAnalyticsQuery({ preset, dateFrom, dateTo }),
                reportType: "sources",
              })
            }
          >
            Export CSV
          </button>
        </div>
        <ClientAnalyticsDateRange
          preset={preset}
          dateFrom={dateFrom}
          dateTo={dateTo}
          onChange={({ preset: p, dateFrom: f, dateTo: t }) => {
            if (p != null) setPreset(p);
            if (f != null) setDateFrom(f);
            if (t != null) setDateTo(t);
          }}
        />
      </section>
      {loading ? <ClientPortalLoading /> : null}
      {errorMessage ? <ClientPortalError message={errorMessage} /> : null}
      {!loading && (
        <>
          <section className="panel-card">
            <ClientSimpleBarChart data={chartData} labelKey="label" valueKey="value" />
          </section>
          <div className="panel-card">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Source</th>
                  <th>Leads</th>
                  <th>New</th>
                  <th>Contacted</th>
                  <th>Won</th>
                  <th>Conversion</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.sourceName}>
                    <td>{r.sourceName}</td>
                    <td>{r.opportunityCount}</td>
                    <td>{r.newCount}</td>
                    <td>{r.contactedCount}</td>
                    <td>{r.closedWonCount}</td>
                    <td>{formatPercent(r.conversionRate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default ClientSourceReportPage;
